import request from '@/utils/request'

let Voucher_distributeApi = {

  /*券发放列表*/
  list(data) {
    return request._post('/shop/plus.voucher_distribute.Index/index', data);
},
/*添加券发放*/
add(data) {
    return request._post('/shop/plus.voucher_distribute.Index/add', data);
},
/*修改券发放*/
edit(data) {
    return request._post('/shop/plus.voucher_distribute.Index/edit', data);
},
/*删除券发放*/
del(data) {
    return request._post('/shop/plus.voucher_distribute.Index/del', data);
},
/*券发放详情*/
detail(data) {
  return request._post('/shop/plus.voucher_distribute.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.voucher_distribute.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.voucher_distribute.Setting/getSetting', data, errorback);
    },
}
export default Voucher_distributeApi;



// WEBPACK FOOTER //
// ./src/api/voucher_distribute.js